export default function templateNameValidator(templateName?: string, existNames?: string[]) {
  if (!templateName || templateName.length <= 0) {
    return 'Название шаблона не может быть пустым';
  }
  if (existNames && existNames.includes(templateName)) {
    return 'Такое название уже существует, придумайте новое';
  }
  return undefined;
}
